import { Popover } from '@mui/material';
import { ImagePickerUpload } from 'src/components/ImagePickerUpload';
import { PopoverProps } from 'src/components/PopoverTrigger';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import useUIState from 'src/state/ui/persistUiState';
import { useBackgroundEffectsCategories } from './constants';

export const VirtualBackgroundPickerPopover = ({
  target,
  handleClose,
}: PopoverProps<any>) => {
  const open = Boolean(target);

  const categories = useBackgroundEffectsCategories();

  const { setFilterParams } = useLivekitRTCState();
  const { setFilterParams: setFilterParamsUIState } = useUIState();

  const handleImageSelect = async (value: string) => {
    const params = {
      virtualBackground: value,
    };

    setFilterParams('image', params);
    setFilterParamsUIState(params);

    handleClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: { p: 1 },
        },
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <ImagePickerUpload
        handleImageSelect={handleImageSelect}
        categories={categories}
      />
    </Popover>
  );
};
